import FastClick from 'fastclick';

import './voltage/standalone-affiliates';

if (!document.body.classList.contains('woocommerce-page')) {
    FastClick.attach(document.body);
}

